<template>
  <div class="menu w-100">
    <span class="mr-2"><b>{{ title }}</b></span>
    <RsButton
      v-for="(item, index) in buttons"
      :key="index"
      class="mr-2 ml-2"
      :active="value === `#${item.key}`"
      variant="secondary-alt"
      @click="changeUrl(item.key)"
    >
      {{ item.name }}
    </RsButton>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { RouteLocationNormalized } from 'vue-router';

export interface IButtonGroup {
  name: string;
  key: string;
}

export default defineComponent({
  name: 'RsButtonMenu',
  props: {
    title: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array as PropType<IButtonGroup[]>,
      required: true,
    },
  },
  data() {
    return {
      value: '' as string,
    };
  },
  watch: {
    $route(newValue: RouteLocationNormalized, oldValue: RouteLocationNormalized) {
      this.value = newValue.hash;
    },
  },
  mounted() {
    if (this.$router.currentRoute.value.hash) {
      this.value = this.$router.currentRoute.value.hash;
    }
  },
  methods: {
    changeUrl(key: string) {
      // A bare-hash `path` is a no-op under Vue Router 4 — pass `hash` instead.
      this.$router.push({ hash: `#${key}` }).catch(() => {});
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.menu{
  height: 60px;
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid $tertiary-gray;
}

</style>
